<template v-profile-guard="'components.dataAccount.read'">
  <div class="account">
    <div class="account-cards">
      <div class="account-cards__item">
        <div class="account__heading">
          {{ $t(`account.edit.acountData`) }}
        </div>
        <CardLogo
          :client-data="clientData"
          @update-logo="(data) => $emit('update-logo', data)"
        ></CardLogo>

        <CardCompany
          :client-data="clientData"
          @update-client="(data) => $emit('update-client', data)"
        ></CardCompany>
      </div>

      <CardPlans v-profile-guard="'components.plan.subscription.read'"></CardPlans>
      <CardSubscription></CardSubscription>
    </div>
  </div>
</template>

<script>
import CardLogo from '../components/Account/Cards/CardLogo';
import CardCompany from '../components/Account/Cards/CardCompany';
import CardPlans from '../components/Account/Cards/CardPlans';
import CardSubscription from '../components/Account/Cards/CardSubscription';

export default {
  name: 'AccountCards',
  components: {
    CardLogo,
    CardCompany,
    CardPlans,
    CardSubscription
  },
  props: {
    clientData: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
